export default defineNuxtPlugin(() => {
  const base = `https://stg.scan.ova-restaurant.com/`

  const links = [
    {
      rel: 'alternate',
      href: `${base}`,
      hreflang: 'x-default'
    },
    {
      rel: 'alternate',
      href: `${base}fr/`,
      hreflang: 'fr'
    },
    {
      rel: 'alternate',
      href: `${base}it/`,
      hreflang: 'it'
    },
    {
      rel: 'alternate',
      href: `${base}de/`,
      hreflang: 'de'
    }
  ]

  useHead({
    link: links
  })
})
